import { render } from "./empty-state.vue?vue&type=template&id=03523f26"
import script from "./empty-state.vue?vue&type=script&lang=js"
export * from "./empty-state.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__